import { useStore } from 'react-redux';
import { saveQueryData } from 'services/query/query.actions';

export function useUpdateQuery(queryKey: string) {
  const store = useStore();
  return ({
    data,
    status,
  }: {
    data?: any;
    status?: 'idle' | 'pending' | 'success' | 'error';
  }) =>
    store.dispatch(
      saveQueryData({
        queryKey,
        data,
        status,
      }),
    );
}
